export default "__VITE_ASSET__Ce9_EYmf__"